export const PageType = {
  Dashboard: 'Dashboard',
  GridListing: 'GridListing',
  Kanban: 'Kanban',
  DetailForm: 'DetailForm',
  FileStorage: 'FileStorage',
  Summary: 'Summary',
} as const;

export type PageType = (typeof PageType)[keyof typeof PageType];
